(function() {
  'use strict';
  angular.module('ringbaPortal').controller('MultiSelectController', MultiSelectController);

  function MultiSelectController(
    _
  ) {
    'ngInject';

    const vm = this;
    let ngModelCtrl;

    vm.selectedOptions = [];
    vm.searchExpressions = {};

    vm.$onChanges = onChanges;
    vm.setNgModelController = setNgModelController;
    vm.selectAllOptions = selectAllOptions;
    vm.selectOption = selectOption;
    vm.removeAllOptions = removeAllOptions;
    vm.removeOption = removeOption;
    vm.onChangeSearchText = onChangeSearchText;

    function onChanges(changesObj) {
      if (changesObj.optionsList) {
        vm.optionsListCopy = angular.copy(vm.optionsList);
        renderViewValue();
      }
    }

    function setNgModelController(ngModelController) {
      ngModelCtrl = ngModelController;
      ngModelCtrl.$render = renderViewValue;
    }

    function selectAllOptions() {
      vm.selectedOptions = angular.copy(vm.optionsListCopy);
      _triggerNgChange(_getModelValue());
    }

    function selectOption(option) {
      vm.selectedOptions.push(option);
      _triggerNgChange(_getModelValue()); // when the reference to a value changes, then only is the ng-change callback called
    }

    function removeAllOptions() {
      vm.selectedOptions = [];
      _triggerNgChange(_getModelValue());
    }

    function removeOption(optionToRemove) {
      _.remove(vm.selectedOptions, function (option) {
        return option[vm.optionValueProperty] === optionToRemove[vm.optionValueProperty];
      });
      _triggerNgChange(_getModelValue());
    }

    function renderViewValue() {
      if (ngModelCtrl && ngModelCtrl.$viewValue && angular.isArray(ngModelCtrl.$viewValue)) {
        vm.selectedOptions = _.filter(vm.optionsListCopy, function (option) {
          return ngModelCtrl.$viewValue.indexOf(option[vm.optionValueProperty]) > -1;
        });
      } else {
        vm.selectedOptions = [];
      }
    }

    function onChangeSearchText(searchText, list) {
      vm.searchExpressions[list] = vm.searchExpressions[list] || {};
      vm.searchExpressions[list][vm.optionDisplayProperty] = {};
      vm.searchExpressions[list][vm.optionDisplayProperty] = searchText;
    }

    function _triggerNgChange(value) {
      if (ngModelCtrl) {
        ngModelCtrl.$setViewValue(angular.copy(value));
      }
    }

    function _getModelValue() {
      return vm.selectedOptions && vm.selectedOptions.length ? _.map(vm.selectedOptions, vm.selectObject ? null : vm.optionValueProperty) : undefined;
    }

  }
})();
